<template>
    <div class="shingle-layers rt-h-screen rt-flex rt-justify-center rt-items-center">
        <div class="rt-w-5/6 rt-rounded-tl-lg rt-rounded-bl-lg
            sm:rt-w-3/5
        ">
            <div class="rt-flex">
                <div class="rt-w-1/2 rt-p-4 rt-bg-white rt-rounded-tl-lg rt-rounded-bl-lg
                    sm:rt-w-3/5
                ">
                    <h1 class="rt-text-2xl rt-font-bold rt-text-red-700 rt-mb-2
                        sm:rt-text-5xl sm:rt-mb-auto
                    ">Shingle Layers</h1>
                    <p>The number of shingle layers that need to be removed impacts price. Scroll below the calculator to learn more!</p>
                    <img :src="imageUrl" class="rt-my-6"/>
                    <div class="rt-flex rt-justify-center rt-mb-4">
                        <button type="button" class="rt-bg-red-600 rt-w-32 rt-h-10 rt-rounded rt-text-white rt-text-lg" @click="prevStep">BACK</button>
                    </div>
                </div>
                <div class="rt-w-1/2 rt-bg-gray-200 rt-p-8 rt-rounded-tr-lg rt-rounded-br-lg
                    sm:rt-w-2/5
                ">
                    <label for="" class="rt-text-gray-600">Choose One: </label>
                    <div class="rt-flex rt-flex-col rt-mt-6">
                        <div class="rt-flex rt-items-center rt-mb-6 group rt-cursor-pointer" v-for="i in 3" :key="i" @click="selectLayer(i)" @mouseover="onMouseOver(i)" @mouseleave="onMouseLeave">
                            <div class="rt-w-1/4 rt-text-center">
                                <span class="rt-inline-block rt-mr-6 rt-h-4 rt-w-4 rt-bg-gray-700 rt-rounded-full group-hover:rt-bg-red-700" :class="{'rt-bg-red-700': layersModel == i}"></span>
                            </div>
                            <div class="rt-w-3/4 rt-flex rt-items-center">
                                <h3 class="rt-mr-2 rt-text-4xl rt-text-gray-700 rt-font-bold group-hover:rt-text-red-700" :class="{'rt-text-red-700': layersModel == i}">{{ i }}</h3>
                                <span class="rt-text-gray-700 group-hover:rt-text-red-700" :class="{'rt-text-red-700': layersModel == i}">{{ i > 1 ? 'Layers' : 'Layer' }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="rt-flex rt-justify-center rt-mt-8">
                        <button type="button" class="rt-bg-red-600 rt-w-32 rt-h-10 rt-rounded rt-text-white rt-text-lg" @click="nextStep">NEXT</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
    name: 'ShingleLayers',
    computed: {
        stepModel: {
            get() {
                return this.step
            },
            set(value) {
                this.setStep(value)
            }
        },
        layersModel: {
            get() {
                return this.layers
            },
            set(value) {
                this.setLayers(value)
            }
        },
        hoverLayerModel: {
            get() {
                return this.hoverLayer
            },
            set(value) {
                this.setHoverLayer(value)
            }
        },
        ...mapState({
            step: state => state.Common.step,
            layers: state => state.ShingleLayers.layers,
            hoverLayer: state => state.ShingleLayers.hoverLayer,
        }),
        imageUrl() {
            if(this.hoverLayerModel) {
                return `${window.roofingData.pluginUrl}dist/${require(`@/assets/images/shingle${this.hoverLayerModel}.png`)}`
            }

            return `${window.roofingData.pluginUrl}dist/${require(`@/assets/images/shingle${this.layersModel}.png`)}`
        }
    },
    methods: {
        ...mapMutations("Common", [
            'setStep',
        ]),
        ...mapMutations("ShingleLayers", [
            'setLayers',
            'setHoverLayer',
        ]),
        nextStep() {
            this.stepModel = 'complexity';
        },
        prevStep() {
            this.stepModel = 'square-footage';
        },
        selectLayer(layer) {
            this.layersModel = layer
        },
        onMouseOver(i) {
            this.hoverLayerModel = i
        },
        onMouseLeave() {
            this.hoverLayerModel = null
        },
    }
}
</script>

<style lang="scss" scoped>
    .shingle-layers {
        background: #2B2B2B;
    }
</style>